import { render, staticRenderFns } from "./DecisionForm.vue?vue&type=template&id=4ebfd760&"
import script from "./DecisionForm.vue?vue&type=script&lang=js&"
export * from "./DecisionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports